import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

declare global {
    interface Window {
        fbq: any;
        _fbq: any;
    }
}

const FacebookPixel: React.FC = () => {
    const { getSetting } = useSettings();
    const location = useLocation();

    // Use hardcoded ID as primary/fallback to ensure it works even if settings haven't loaded
    const pixelId = getSetting('facebook_pixel_id') || '1116177376953373';

    useEffect(() => {
        if (!pixelId) return;

        const f = window as any;
        if (f.fbq) return;

        const n = function (this: any, ...args: any[]) {
            if (f.fbq.callMethod) {
                f.fbq.callMethod.apply(f.fbq, args);
            } else {
                f.fbq.queue.push(args);
            }
        } as any;

        if (!f._fbq) f._fbq = n;
        f.fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];

        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';

        const s = document.getElementsByTagName('script')[0];
        if (s && s.parentNode) {
            s.parentNode.insertBefore(t, s);
        }

        window.fbq('init', pixelId);
    }, [pixelId]);

    // Track PageView on route changes
    useEffect(() => {
        if (window.fbq && pixelId) {
            window.fbq('track', 'PageView');
        }
    }, [location, pixelId]);

    return null;
};

export default FacebookPixel;
